/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { authReducer } from './auth.slice';
import { authModalReducer } from './authModal.slice';

export * from './AuthContext';
export * from './AuthModal';
export { authModalActions } from './authModal.slice';
export {
    csrClearSelectedCustomer,
    csrLoggedIn,
    csrSelectCustomer,
    csrSession,
    csrSessionWithUrl,
    hydrateFromStorage,
    logout,
    writeSession,
} from './authSession';
export type { AuthAccount, AuthSession, AuthSliceState } from './auth.slice';

export const authReducers = {
    authModal: authModalReducer,
    // Later key wins over sarsaparilla's `auth` loginReducer when public
    // stores spread `{...sarsaparillaReducers, ...authReducers}`.
    auth: authReducer,
};
